import { useState } from "react";

export default function useDrawer() {
	const [isOpen, setIsOpen] = useState();
	return {
		isOpen,
		setIsOpen,
	};
}
